
import {getwxConfig} from '../../api/data.js'
import wx from 'jweixin-module'
export default {
  wxShowMenu: function(imgUrl, desc, title) {
    let data = location.href.split('#')[0]; //获取当前页面地址
   let link = data + 'static/html/redirect.html?app3Redirect=' + encodeURIComponent(window.location.href);
    //let link = data
    //console.log("11imgUrl:"+imgUrl)
    getwxConfig(data).then(res=>{
      //console.log(link)
      let getMsg = res.data.data;
      wx.config({
        debug: false, //生产环境需要关闭debug模式
        appId: getMsg.appId, //appId通过微信服务号后台查看
        timestamp: getMsg.timestamp, //生成签名的时间戳
        nonceStr: getMsg.nonceStr, //生成签名的随机字符串
        signature: getMsg.signature, //签名
        jsApiList: [ //需要调用的JS接口列表
          'updateAppMessageShareData', //分享给好友
          'updateTimelineShareData', //分享到朋友圈

        ]
      });
      wx.checkJsApi({
        jsApiList: [ //需要调用的JS接口列表
          'updateAppMessageShareData', //分享给好友
          'updateTimelineShareData', //分享到朋友圈
        ], // 需要检测的JS接口列表，所有JS接口列表见附录2,
        success: function(res) {
          // 以键值对的形式返回，可用的api值true，不可用为false
          // 如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}
        }
      });
      //console.log("res.data")
     // console.log(res.data)

      wx.ready(function () {
        //分享给好友
       // console.log("wx.updateAppMessageShareData")
        //console.log(wx.updateAppMessageShareData)
        if(wx.updateAppMessageShareData){
          wx.updateAppMessageShareData({
            title: title, // 分享标题
            desc: desc, // 分享描述
            link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: imgUrl, // 分享图标
            success: function () {
              // 设置成功
            }
          })
        }else{//onMenuShareAppMessage:fail
          wx.onMenuShareAppMessage({
            title: title, // 分享标题
            desc: desc, // 分享描述
            link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: imgUrl, // 分享图标
            success: function () {
              // 设置成功
            }
          });
        }
        //分享到朋友圈
        if(wx.updateTimelineShareData){
          wx.updateTimelineShareData({
            title: title, // 分享标题
            desc: desc, // 分享描述
            link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: imgUrl, // 分享图标
            success: function () {
              // 设置成功
            }
          })
        }else{
          wx.onMenuShareTimeline({
            title: title, // 分享标题
            desc: desc, // 分享描述
            link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: imgUrl, // 分享图标
            success: function () {
              // 用户点击了分享后执行的回调函数
            }
          });
        }
        wx.onMenuShareQQ({
          title: title, // 分享标题
          desc: desc, // 分享描述
          link: link, // 分享链接
          imgUrl: imgUrl, // 分享图标
          success: function () {
            // 用户确认分享后执行的回调函数
          },
          cancel: function () {
            // 用户取消分享后执行的回调函数
          }
        });

        wx.onMenuShareWeibo({
          title: title, // 分享标题
          desc: desc, // 分享描述
          link: link, // 分享链接
          imgUrl: imgUrl, // 分享图标
          success: function () {
            // 用户确认分享后执行的回调函数
          },
          cancel: function () {
            // 用户取消分享后执行的回调函数
          }
        });

      })
      wx.error(function (res) {
        // config信息验证失败会执行error函数，如签名过期导致验证失败，
        // 具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，
        // 对于SPA可以在这里更新签名。
        console.log('分享失败')
        console.log(res)
        //alert('分享失败')
      })
    }, function (res) {
      console.log(res)
      console.log(parseInt(res.code))
    })
  }





}




// WEBPACK FOOTER //
// ./src/assets/js/wxshare.js